<template>
  <span class="sport-live-tv-alert-icon" aria-hidden="true">!</span>
</template>

<style lang="scss" scoped>
.sport-live-tv-alert-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: $bg-red;
  color: $white;
  font-size: 28px;
  font-weight: 700;
}
</style>
